module.exports = __webpack_public_path__ + "static/media/background-pattern-image.edadcb6f.webp";